<template>
  <div class="user">
    <div class="photo">
      <img :src="avatar" alt="avatar" />
    </div>
    <div class="user-info">
      <a
        data-toggle="collapse"
        :aria-expanded="!isClosed"
        @click.stop="toggleMenu"
        @click.capture="clicked"
      >
        <span v-if="$route.meta.rtlActive">
          {{ rtlTitle }}
          <b class="caret"></b>
        </span>
        <span v-else>
          {{ title }}
          <b class="caret"></b>
        </span>
      </a>

      <collapse-transition>
        <div v-show="!isClosed">
          <ul class="nav">
            <slot>
              <li>
                <a
                  v-if="$route.meta.rtlActive"
                  href="#"
                  @click="openChangePassword()"
                >
                  <span class="sidebar-mini">مع</span>
                  <span class="sidebar-normal">ملف</span>
                </a>
                <a v-else href="#" @click="openChangePassword()">
                  <span class="sidebar-mini">CP</span>
                  <span class="sidebar-normal">Change Password</span>
                </a>
              </li>
              <li>
                <a v-if="$route.meta.rtlActive" href="#" @click="logout()">
                  <span class="sidebar-mini">مع</span>
                  <span class="sidebar-normal">ملف</span>
                </a>
                <a v-else href="#" @click="logout()">
                  <span class="sidebar-mini">LO</span>
                  <span class="sidebar-normal">Log out</span>
                </a>
              </li>
            </slot>
          </ul>
        </div>
      </collapse-transition>
    </div>
  </div>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";
import Swal from "sweetalert2";
import axios from "axios";
import $ from "jquery";
import auth from "@/services/auth";

export default {
  components: {
    CollapseTransition
  },
  props: {
    title: {
      type: String,
      default: "Frosina Trajkovska"
    },
    rtlTitle: {
      type: String,
      default: "تانيا أندرو"
    },
    avatar: {
      type: String,
      default: "/img/faces/avatar.jpg"
    }
  },
  data() {
    return {
      isClosed: true
    };
  },
  methods: {
    clicked: function(e) {
      e.preventDefault();
    },
    toggleMenu: function() {
      this.isClosed = !this.isClosed;
    },
    logout: function() {
      auth.removeToken();
      this.$router.push({ name: "Login" });
    },
    openChangePassword: function() {
      Swal.fire({
        title: "Change your password",
        html: `<div class="md-field md-form-group md-theme-default"><i class="md-icon md-icon-font md-theme-default">lock_outline</i><input type="password" class="md-input md-rose" placeholder="Enter your current password" name="currentPassword" id="currentPassword"></div>
          <div class="md-field md-form-group md-theme-default"><i class="md-icon md-icon-font md-theme-default">lock_outline</i><input type="password"  class="md-input md-rose" placeholder="Enter your new password" name="newPassword" id="newPassword"></div>
          <div class="md-field md-form-group md-theme-default"><i class="md-icon md-icon-font md-theme-default">lock_outline</i><input type="password"  class="md-input md-rose" placeholder="Repeat your new password" name="repeatPassword" id="repeatPassword"></div>
          `,
        showCancelButton: true,
        confirmButtonClass: "md-button md-rose",
        cancelButtonClass: "md-button md-warning",
        buttonsStyling: false,
        confirmButtonText: "Change"
      }).then(result => {
        if (result.value) {
          var currentPassword = $("#currentPassword").val();
          var newPassword = $("#newPassword").val();
          var repeatPassword = $("#repeatPassword").val();

          if (!currentPassword || !newPassword || !repeatPassword) {
            Swal.fire({
              title: "Error",
              text: "All fields are reqired",
              type: "error",
              confirmButtonClass: "md-button md-info",
              buttonsStyling: false
            });
          } else if (newPassword !== repeatPassword) {
            Swal.fire({
              title: "Error",
              text: `"New password" and "Repeat password" must match`,
              type: "error",
              confirmButtonClass: "md-button md-info",
              buttonsStyling: false
            });
          } else {
            axios
              .post("api/Auth/ResetPassword", {
                CurrentPassword: currentPassword,
                NewPassword: newPassword,
                RepeatPassword: repeatPassword
              })
              .then(() => {
                Swal.fire({
                  title: "Success",
                  text: "Your password has been changed",
                  type: "success",
                  confirmButtonClass: "md-button md-success",
                  buttonsStyling: false
                });
              })
              .catch(errors => {
                console.log(errors);
                Swal.fire({
                  title: "Error",
                  text: "Password change failed",
                  type: "error",
                  confirmButtonClass: "md-button md-info",
                  buttonsStyling: false
                });
              });
          }
        }
      });
    }
  }
};
</script>
<style>
.collapsed {
  transition: opacity 1s;
}
</style>
